import React from 'react';
import {
  Carousel,
  CarouselNext,
  CarouselItem,
  CarouselContent,
  CarouselPrevious,
} from '@design-system/Carousel';

import { cn } from '@/utils/styles';
import { formatTextToParagraphs } from '@/utils/string/formatTextToParagraphs';

import { IDoctorsNoteResponse } from '@viome/viome-base/src/usecase/Health/Health.model';

interface DoctorsNotesProps {
  notes: IDoctorsNoteResponse;
}

const gradientOptions = [
  'from-[#9EA1B74D] to-[#0026AE4D]',
  'from-[#9EA1B74D] to-[#AE008B4D]',
  'from-[#9EB7AB4D] to-[#0084C24D]',
];

const getGradientClass = (index: number) => {
  const gradientIndex = index % gradientOptions.length;
  return gradientOptions[gradientIndex];
};

export const DoctorsNotes: React.FC<DoctorsNotesProps> = ({ notes }) => {
  if (!notes?.length || 0) return null;

  return (
    <div className="mt-6 w-full">
      <h2 className="dark typography-h1 text-primary mb-4"></h2>
      <h1 className="dark typography-h1 text-primary mb-4">Clinician's Notes</h1>
      <p className="dark typography-body text-secondary max-w-[37rem] mb-6">
        Here's a summary of key takeaways for this score, highlighting where
        your recommendations and formulas will focus.
      </p>
      <Carousel
        className="relative"
        opts={{
          align: 'start',
          dragFree: true,
        }}
      >
        <CarouselContent className="-ml-6 gap-2 select-none mb-6">
          {notes.map((note, index) => (
            <CarouselItem
              key={`doctor-note-${index}`}
              className="pl-6 basis-80"
            >
              <div
                className={cn(
                  'w-80 h-full',
                  'px-6 py-6',
                  'bg-gradient-to-b rounded shadow-lg',
                  getGradientClass(index),
                )}
              >
                <p className="typography-h3 text-secondary mb-4">
                  {formatTextToParagraphs(note.description)}
                </p>
              </div>
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselPrevious variant="ghost" />
        <CarouselNext variant="ghost" />
      </Carousel>
    </div>
  );
};
